module.exports = __webpack_public_path__ + "img/optionsCheck.018d49ae.svg";